<template>
  <div class="row">
    <template>
      <div class="flex w-80">
        <div class="w-50 question-wrap">
          <div class="checkbox-wrap">
            <div
              v-if="!isProcessing && !isLoading"
              class="checkbox"
              :class="{ checked: isChecked }"
            >
              <or-icon icon="done" />

              <input
                type="checkbox"
                :checked="isChecked"
                @change="toggleCheckbox"
              />
            </div>

            <div v-else class="loader-wrap">
              <or-icon-button
                icon="refresh"
                size="small"
                type="secondary"
                :loading="true"
              />
            </div>
          </div>

          <div class="utterance-wrap">
            <utterance
              :value="utterance"
              :allow-to-delete="false"
              :autogenerated="true"
              @update-question="onSaveUtterance"
            />
          </div>
        </div>

        <div class="w-50 answer-wrap">
          <intent-editor
            :intentString="$props.utterance.intent"
            :utterance="$props.utterance"
            @save="onIntentSave"
          />
        </div>
      </div>

      <div
        class="w-20 context-wrap"
        :class="{ 'is-editing': isEditingContext }"
      >
        <contextEditor
          :value="utterance.application"
          :is-editing-context.sync="isEditingContext"
          :is-loading="isLoading"
          @save="onContextSave"
        />
      </div>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'
import KnowledgeBus from '@/KnowledgeBus'
import { mapState, mapActions } from 'vuex'
import utterance from '@/components/common/utterance/utterance'
import intentEditor from '@/components/autogenerated/intent-editor'
import contextEditor from '@/components/autogenerated/context-editor'

export default {
  components: {
    utterance,
    intentEditor,
    contextEditor
  },

  props: {
    utterance: Object,
    checkedSet: Array,
    isAccepting: Boolean,
    isDeleting: Boolean
  },

  computed: {
    ...mapState('knowledgebase', ['intents', 'categories']),

    isChecked () {
      return _.includes(this.checkedSet, this.utterance.id)
    },

    isProcessing () {
      return (
        _.includes(this.$props.checkedSet, this.$props.utterance.id) &&
        (this.$props.isAccepting || this.$props.isDeleting || this.isLoading)
      )
    }
  },

  data () {
    return {
      isLoading: false,
      isEditingContext: false
    }
  },

  methods: {
    ...mapActions('knowledgebase/autogenerated', ['updateAutogenerated']),

    async onSaveUtterance (value) {
      this.isLoading = true
      await this.updateAutogenerated({ data: value, appId: value.application })
      this.isLoading = false
    },

    async onIntentSave (value) {
      this.isLoading = true
      await this.updateAutogenerated({
        data: { ...this.utterance, intent: value },
        appId: this.utterance.application
      })
      this.isLoading = false
    },

    async onContextSave (value) {
      this.isLoading = true
      await this.updateAutogenerated({ data: this.utterance, appId: value })
      this.isLoading = false
    },

    toggleCheckbox () {
      KnowledgeBus.$emit('row-checkbox::toggle', this.utterance.id)
    }
  }
}
</script>

<style lang="scss" scoped>
.row {
  border-bottom: solid 1px $or-grey-medium;

  .checkbox-wrap {
    width: 16px;
    margin-right: 8px;

    .checkbox {
      display: flex;
      position: relative;
      justify-content: center;
      align-items: center;
      width: 16px;
      height: 16px;
      border: 1px solid $or-grey-medium;
      border-radius: 2px;

      &.checked {
        background-color: $or-blue;
        border: none;

        &:hover {
          background-color: lighten($or-blue, 5%);
          transition: all 0.2s ease;
        }

        .material-icons {
          display: block;
        }
      }

      input {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        opacity: 0;

        &:hover {
          cursor: pointer;
        }
      }

      .material-icons {
        display: none;
        color: $or-white;
        font-size: 12px;
      }
    }

    .loader-wrap {
      display: flex;
      position: relative;
      justify-content: center;
      align-items: center;
      width: 16px;
      height: 16px;
    }
  }

  .w {
    &-80 {
      width: 80%;
      border-right: solid 1px $or-grey-medium;
    }

    &-20 {
      width: 20%;
    }

    &-50 {
      width: 50%;
      &:first-child {
        border-right: solid 1px $or-grey-medium;
      }
    }
  }

  .question-wrap {
    display: flex;
    align-items: center;
    padding-left: $sp-2;

    .sequence {
      flex-grow: 1;
    }

    .utterance-wrap {
      flex-grow: 1;
    }
  }
}
</style>

<style lang="scss">
.answer-wrap > .kb-autocomplete,
.context-wrap > .kb-autocomplete {
  margin: 0;

  .ui-autocomplete__content .ui-autocomplete__label .ui-autocomplete__input {
    background: transparent !important;
    border: none !important;
  }
}

.context-wrap {
  display: flex;
  align-items: stretch;

  // &.is-editing {
  //     border: solid 1px $or-blue;
  // }
}
</style>
